import { 
  updateTenantProduct, 
  getProductVariations, 
  assignProductVariant,
  updateTenantProductCustomerView,
  assignParentProducts
} from "../../admin/product";
import { UpdateTenantProductPayload } from "@surgia/ui/dtos/request";
import { UpdateCustomerViewPayload } from "../../admin/product";

// Query store
export const productQueries = {
  queries: {
    productVariations: (parentProductId: string, tenantId: string) => ({
      queryKey: ['admin', 'product', 'variations', parentProductId, tenantId],
      queryFn: async () => {
        return getProductVariations(parentProductId, tenantId);
      }
    })
  },
  mutations: {
    updateTenantProduct: (tenantProductId: string) => ({
      mutationKey: ['admin', 'product', 'update-tenant-product', tenantProductId],
      mutationFn: async (payload: UpdateTenantProductPayload) => {
        return updateTenantProduct(tenantProductId, payload);
      }
    }),
    assignProductVariant: (tenantId: string) => ({
      mutationKey: ['admin', 'product', 'assign-variant', tenantId],
      mutationFn: async (payload: any) => {
        return assignProductVariant(tenantId, payload);
      }
    }),
    assignParentProducts: (tenantId: string) => ({
      mutationKey: ['admin', 'product', 'assign-parent-products', tenantId],
      mutationFn: async (payload: any) => {
        return assignParentProducts(tenantId, payload);
      }
    }),
    updateTenantProductCustomerView: (tenantProductId: string) => ({
      mutationKey: ['admin', 'product', 'update-tenant-product-customer-view', tenantProductId],
      mutationFn: async (payload: UpdateCustomerViewPayload) => {
        return updateTenantProductCustomerView(tenantProductId, payload);
      }
    })
  }
};
